<template>
  <div>
    <template v-if="loadGame">
      <div>
        <resource-nav-bar
            v-if="resource"
            :resource="resource"
            @open-about="handleAboutClick"
        >
          <template v-slot:buttons-right>
            <b-nav-text v-if="settings_showProgressStats">
              Turns:
              <b-icon icon="arrow90deg-left" />
              <b-badge :variant="finish ? 'dark' : 'success'" style="margin:10px">
                {{ turns }}
              </b-badge>
              <b-icon icon="clock" font-scale="1" style="margin-left: 25px" />
              <b-badge :variant="finish ? 'dark' : 'success'" style="margin:10px">
                {{ `${min}:${sec}` }}
              </b-badge>
            </b-nav-text>
            <b-button
                variant="outline-primary"
                size="md"
                class="my-2 my-md-0"
                @click="peekFlip"
            >
              Peek
            </b-button>
            <b-button
                variant="outline-primary"
                size="md"
                class="my-2 my-md-0"
                @click="handleResetGame(true)"
                style="margin: 10px"
            >
              New Game
            </b-button>
          </template>
        </resource-nav-bar>
      </div>
      <div class="row">
        <div
          v-for="aCard in memoryCards"
          class="col-auto mb-3 flip-container"
          :class="{ flipped: aCard.isFlipped, matched: aCard.isMatched }"
          @click="flipCard(aCard)"
        >
          <memory-card
            :assets-url-home="assetsURLHome"
            :card="aCard"
            :cover-img-path="cardsThemeCoverImgPath"
            :height="cardHeight"
            :width="cardWidth"
          />
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import _ from "lodash";
import Vue from "vue";
import ResourceBlockDisplay from "@/mixins/resourceBlocks/Display";
import ResourceNavBar from "@/components/blockResources/_components/resourceNavBar";
import MemoryCard from "./card";
import optionsJSON from "../../assets/json/optionsJSON.json";
import VueConfetti from "vue-confetti";

Vue.use(VueConfetti);

export default {
  name: "Display_MatchGame",
  mixins: [ResourceBlockDisplay],
  components: {
    MemoryCard,
    ResourceNavBar
  },
  mounted() {
    this.handleResetGame(true);
    //THIS APPS SOUND EFFECTS -- onlyset up once
  },
  computed: {
    loadGame() {
      return true;
    },
    themesJSON(){
      return this.optionsJSON && this.optionsJSON.theme  && this.optionsJSON.theme.items
          ? this.optionsJSON.theme.items : null
    },
    cardTheme() {
      //has cards and other values
      if (this.themesJSON && Array.isArray(this.themesJSON ) && this.settings_cardTheme) {
        let theThemeData = this.themesJSON.filter(aTheme => {
          return aTheme.name === this.settings_cardTheme;
        });
        return theThemeData[0];
      }
      return this.themesJSON[0]; //default theme
    },
    cardHeight(){
      return window.innerHeight/(this.settings_gridSize+2);
    },
    cardWidth(){
      return window.innerWidth/(this.settings_gridSize+2);
    },
    /* SETTINGS */
    settings_showProgressStats() {
      const _default = true;
      return this.settings && this.settings.user
        ? this.settings.user._isDisplayStats
        : _default;
    },
    settings_cardTheme() {
      return this.settings && this.settings.user
        ? this.settings.user.theme
        : "default";
    },
    settings_gridSize() {
      return this.settings && this.settings.user
          ? this.settings.user.gridSize
          : 2;
    },
    settings_hasBgMusic() {
      return this.settings && this.settings.user
        ? this.settings.user._hasBGMusic
        : true;
    },
    settings_isSoundOn() {
      return this.settings && this.settings.user
        ? this.settings.user._isSoundOn
        : true;
    },
    /* GAMEPLAY */
    sec() {
      if (this.totalTime.seconds < 10) {
        return "0" + this.totalTime.seconds;
      }
      return this.totalTime.seconds;
    },
    min() {
      if (this.totalTime.minutes < 10) {
        return "0" + this.totalTime.minutes;
      }
      return this.totalTime.minutes;
    }
  },
  watch: {
    settings(newValue, oldValue) {
      this.handleResetGame();
    }
  },
  methods: {
    setUpTheme() {
      //***CARDS
      this.cards = this.cardTheme && this.cardTheme.cards ?
           this.cardTheme.cards : this.defaultTheme.cards;

      //Set Cover
      this.cardsThemeCoverImgPath =
        this.cardTheme &&
        this.cardTheme.coverImgPath && this.cardTheme.coverImgPath.length > 0
          ? this.cardTheme.coverImgPath
          : this.defaultTheme.coverImgPath;

      //BACKGROUND MUSIC- Can also choose from PlayList
      if (this.settings_hasBgMusic) {
          this.playList.push(
              `${this.assetsURLHome}${
                this.cardTheme && this.cardTheme.bgMusicPath ?
                    this.cardTheme.bgMusicPath: this.defaultTheme.bgMusicPath
              }`
          );
          this.playRepeat();
       }else{
        if (this.player) {
          this.playerCheckClear();
        }
      }


        //**SOUND EFFECTS
        if (this.settings_isSoundOn) {
          //switch it to hasSoundEffects or playSoundEffects
          this.setUpSoundEffectsFromTheme(this.cardTheme);
        }
    },
    setUpSoundEffectsFromTheme(cardTheme) {
      if (cardTheme.soundEffects && cardTheme.soundEffects.cardFlipSoundPaths &&
          Array.isArray(cardTheme.soundEffects.cardFlipSoundPaths)){
        this.soundEffects.flip = new Audio(
            `${this.assetsURLHome}${cardTheme.soundEffects.cardFlipSoundPaths[0].path}`);
      }

      if (cardTheme.soundEffects && cardTheme.soundEffects.cardsMatchSoundPaths &&
          Array.isArray(cardTheme.soundEffects.cardsMatchSoundPaths)){
        this.soundEffects.matched = new Audio(
            `${this.assetsURLHome}${cardTheme.soundEffects.cardsMatchSoundPaths[2].path}`);
      }

      if (cardTheme.soundEffects && cardTheme.soundEffects.cardsMatchSoundPaths &&
          Array.isArray(cardTheme.soundEffects.cardsMatchSoundPaths)){
        this.soundEffects.win = new Audio(
            `${this.assetsURLHome}${cardTheme.soundEffects.cardsMatchSoundPaths[0].path}`);
      }
    },
    handleResetGame(shallPeek) {
      this.setUpTheme();
      clearInterval(this.interval);

      //Build Deck from cards based on gridsize set in settinsg
      const deck = this.settings_gridSize
          ? this.cards.slice(0, this.settings_gridSize)
          : this.cards;

      //reset the matching of cards and the  flipping
      deck.forEach(card => {
        Vue.set(card, "isFlipped", false);
        Vue.set(card, "isMatched", false);
      });

      setTimeout(() => {
        this.memoryCards = [];
        this.memoryCards = _.shuffle(
            this.memoryCards.concat(_.cloneDeep(deck), _.cloneDeep(deck))
        );

        //Give each memory card a unique id to fix bug of matching with itself
        let i = 0;
        this.memoryCards.forEach(card => {
          Vue.set(card, "id", i++);
        });

        this.totalTime.minutes = 0;
        this.totalTime.seconds = 0;
        this.start = false;
        this.finish = false;
        this.turns = 0;
        this.flippedCards = [];
      }, 600);
      //
      if (shallPeek) this.peekFlip();

      this.handleAppLog({
        name: "display.reset",
        payload: { shallPeek: shallPeek },
        level: "info"
      });
    },
    peekFlip() {
      this.memoryCards.forEach(card => {
        if (!card.isMatched) Vue.set(card, "isFlipped", true);
      });
      setTimeout(() => {
        this.memoryCards.forEach(card => {
          if (!card.isMatched) Vue.set(card, "isFlipped", false);
        });
      }, 2000);

      this.handleAppLog({
        name: "display.peekFlip",
        payload: {},
        level: "info"
      });
    },
    flipCard(card) {
      this.handlePlaySoundEffectFlipped();

      if (card.isMatched || card.isFlipped || this.flippedCards.length === 2)
        return;

      if (!this.start) {
        this._startGame();
      }

      card.isFlipped = true;

      if (this.flippedCards.length < 2) this.flippedCards.push(card);
      if (this.flippedCards.length === 2) this._match(card);

      this.handleAppLog({
        name: "display.flipCard",
        payload: {},
        level: "info"
      });
    },
    _match(card) {
      this.turns++;
      if (
        this.flippedCards[0].name === this.flippedCards[1].name &&
        this.flippedCards[0].id !== this.flippedCards[1].id
      ) {
        this.handlePlaySoundEffectMatched();

        setTimeout(() => {
          this.flippedCards.forEach(card => (card.isMatched = true));
          this.flippedCards = [];

          //All cards matched ?
          if (this.memoryCards.every(card => card.isMatched === true)) {
            clearInterval(this.interval);
            this.finish = true;
            //Celebrate
            this.handleGameEnded();
          }
        }, 400);
      } else {
        setTimeout(() => {
          this.flippedCards.forEach(card => {
            card.isFlipped = false;
            this.handlePlaySoundEffectFlipped();
          });
          this.flippedCards = [];
        }, 800);
      }

      this.handleAppLog({
        name: "display._match",
        payload: { turns: this.turns, match: true, card: card },
        level: "info"
      });
    },
    _startGame() {
      this._tick();
      this.interval = setInterval(this._tick, 1000);
      this.start = true;

      this.handleAppLog({
        name: "display._startGame",
        payload: { interval: this.interval },
        level: "info"
      });
    },
    _tick() {
      if (this.totalTime.seconds !== 59) {
        this.totalTime.seconds++;
        return;
      }

      this.totalTime.minutes++;
      this.totalTime.seconds = 0;
    },
    handleGameEnded() {
      this.handlePlaySoundEffectWin();
      //@TODO- Add the game ended back in
      // this.handleShowGameEndModal();
    },
    handlePlaySoundEffectFlipped() {
      debugger
      if(this.soundEffects.flip) this.soundEffects.flip.play();
    },
    handlePlaySoundEffectMatched(){
      if (this.soundEffects.matched) this.soundEffects.matched.play();
    },
    handlePlaySoundEffectWin(){
      if(this.soundEffects.win) this.soundEffects.win.play();
    },
    handleCelebrateWin(){
      if(this.soundEffects.win) this.soundEffects.win.play();
      this.$confetti.start({
        particles: [
          {
            type: type
          }
        ],
        defaultColors: ["red", "pink", "#ba0000"]
      });
      this.timerId = setTimeout(() => {
        this.$confetti.stop();
      }, interval);
    },
    handleShowGameEndModal() {
      this.winningModal = ''
      this.$bvModal.msgBoxConfirm('Want to play again?.', {
        title: 'Great Work',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'success',
        okTitle: 'YES',
        cancelTitle: 'NO',
        footerClass: 'p-2',
        hideHeaderClose: true,
        hideHeader:true,
        centered: true,
        style:"background-color:red;"
      })
          .then(value => {
            this.winningModal = value
          })
          .catch(err => {
            // An error occurred
          })
    }
  },
  data() {
    return {
      /* Overrides */
      assetsURLHome: "/assets/apps/matchgame/",
      winningModal: '',
      /* App Specific */
      optionsJSON,
      defaultTheme : {
        name: "animals",
        _created_at: 1234,
        coverImgPath: "_covers/animals.png",
        bgMusicPath:"_audio/bgmusic/dreamit.mp3",
        cards:[
          {
            name: "bear",
            imgPath: "animals/bear.png",
            isFlipped: false,
            isMatched: false,
            title: "Bear",
            audioURL: ""
          },
          {
            name: "1",
            imgPath: "fruits/apple.png",
            isFlipped: false,
            isMatched: false,
            title: "1",
            audioURL: ""
          },
          {
            name: "2",
            imgPath: "fruits/banana.png",
            isFlipped: false,
            isMatched: false,
            title: "2",
            audioURL: ""
          },
          {
            name: "3",
            imgPath: "fruits/blueberries.png",
            isFlipped: false,
            isMatched: false,
            title: "3",
            audioURL: ""
          }
        ]
      },
      cards: [],
      cardsThemeCoverImgPath: "",
      memoryCards: [],
      flippedCards: [],
      finish: false,
      start: false,
      turns: 0,
      totalTime: {
        minutes: 0,
        seconds: 0
      },
      soundEffects: {
        flip: null,
        matched: null,
        win: null
      }
    };
  }
};
</script>

<style lang="scss" scoped>
.flip-container {
  -webkit-perspective: 1000;
  -moz-perspective: 1000;
  -o-perspective: 1000;
  perspective: 1000;
  min-height: 120px;
  cursor: pointer;
}
.front,
.back {
  -webkit-backface-visibility: hidden;
  -moz-backface-visibility: hidden;
  -o-backface-visibility: hidden;
  backface-visibility: hidden;
  -webkit-transition: 0.6s;
  -webkit-transform-style: preserve-3d;
  -moz-transition: 0.6s;
  -moz-transform-style: preserve-3d;
  -o-transition: 0.6s;
  -o-transform-style: preserve-3d;
  -ms-transition: 0.6s;
  -ms-transform-style: preserve-3d;
  transition: 0.6s;
  transform-style: preserve-3d;
  top: 0;
  left: 0;
  width: 100%;
}
.back {
  -webkit-transform: rotateY(-180deg);
  -moz-transform: rotateY(-180deg);
  -o-transform: rotateY(-180deg);
  -ms-transform: rotateY(-180deg);
  transform: rotateY(-180deg);
  position: absolute;
}
.flip-container.flipped .back {
  -webkit-transform: rotateY(0deg);
  -moz-transform: rotateY(0deg);
  -o-transform: rotateY(0deg);
  -ms-transform: rotateY(0deg);
  transform: rotateY(0deg);
}
.flip-container.flipped .front {
  -webkit-transform: rotateY(180deg);
  -moz-transform: rotateY(180deg);
  -o-transform: rotateY(180deg);
  -ms-transform: rotateY(180deg);
  transform: rotateY(180deg);
}
.matched {
  opacity: 0.3;
}
</style>
